module.exports = __webpack_public_path__ + "img/惠动乐@2x.60229b51.png";